module.exports = __webpack_public_path__ + "static/media/ball-triangle-loader-gray.048cc158.svg";